<template>
  <b-modal
    id="auth-modal"
    :modal-class="'default-modal'"
    :hide-footer="true"
    @hidden="reset"
  >
    <template v-slot:modal-title>
      {{ formTitle }}
    </template>

    <template v-slot:default>

      <AlertWraper
        :content="errors"
        type="error"
      />

      <div class="login-form" v-if="formType !== 'use_2fa'">

        <form class="default-form mt-4" @submit.prevent="submitForm">
          <template v-if="formType === 'register'">
            <div class="form-group default-input">
              <input type="text" class="form-control with-label" v-model.trim="$v.register.name.$model" placeholder="" />
              <label>Nome</label>
            </div>
            <div class="form-group default-input">
              <input type="text" class="form-control with-label" v-model.trim="$v.register.username.$model" placeholder="" />
              <label>Nome de usuário</label>
            </div>
            <div class="form-group default-input">
              <input type="text" class="form-control with-label" v-model.trim="$v.register.email.$model" placeholder="" />
              <label>
                E-mail
              </label>
            </div>
            <div class="form-group default-input">
              <i class="fa field-icon" :class="[pwdIcon]" @click="hidePassword = !hidePassword"></i>
              <input :type="passwordFieldType" class="form-control with-label" v-model.trim="$v.register.password.$model" placeholder="" />
              <label>Senha</label>
            </div>
            <div class="form-group default-input">
              <i class="fa field-icon" :class="[pwdConfirmIcon]" @click="hideConfirmationPassword = !hideConfirmationPassword"></i>
              <input :type="confirmationPasswordFieldType" class="form-control with-label" v-model.trim="$v.register.password_confirmation.$model" placeholder="" />
              <label>Confirme sua senha</label>
            </div>
            <div>
              <p class="font-size-small text-center">
                Ao se cadastrar, você concorda com os nossos <router-link :to="{ name: 'statics.terms' }" class="link-color2 font-weight-bold" target="_blank">Termos de Uso</router-link>, nossa <router-link :to="{ name: 'statics.privacy' }" class="link-color2 font-weight-bold" target="_blank">Política de Privacidade</router-link> e <router-link :to="{ name: 'statics.moderation' }" class="link-color2 font-weight-bold" target="_blank">Regras de Moderação</router-link>.
              </p>
            </div>
          </template>
          <template v-else>
            <div class="form-group default-input">
              <input type="text" class="form-control with-label" v-model.trim="$v.login.email.$model" placeholder="" />
              <label>
                E-mail ou nome de usuário
              </label>
            </div>
            <div class="form-group default-input">
              <i class="fa field-icon" :class="[pwdIcon]" @click="hidePassword = !hidePassword"></i>
              <input :type="passwordFieldType" class="form-control with-label" v-model.trim="$v.login.password.$model" placeholder="" />
              <label>Senha</label>
            </div>
            <div class="d-flex justify-content-end align-items-start" v-if="formType === 'login'">
              <div v-if="1==2">
                <div class="form-group">
                  <div class="styled-checkbox">
                    <label for="remember">
                      <input id="remember" type="checkbox" name="remember" />
                      <span></span>
                      Lembrar de mim
                    </label>
                  </div>
                </div>
              </div>
              <div>
                <router-link
                  class="text-color1 font-size-small text-decoration-underline"
                  :to="{ name: 'password.email' }"
                  @click.native="$bvModal.hide('auth-modal')"
                >
                  Esqueci minha senha
                </router-link>
              </div>
            </div>
          </template>

          <div class="text-center mt-4">
            <Button
              type="submit"
              class="btn btn-primary"
              :disabled="$v.$invalid"
              :loading="isLoading"
              v-if="formType === 'login'"
            >
              Entrar
            </Button>
            <Button
              type="submit"
              class="btn btn-primary"
              :disabled="$v.$invalid"
              :loading="isLoading"
              v-else
            >
              Registrar
            </Button>
          </div>

        </form>

        <div class="text-center mt-2" v-if="formType === 'login'">
          <p class="small">ou</p>
          <FacebookLogin @token="loginWithToken" :loading="isFbLoading"/>
        </div>

        <hr class="h-1 background-color2 my-4" />

        <div class="text-center">
          <button
            type="button"
            class="btn btn-outline-color2"
            @click="formType = 'register'"
            v-if="formType === 'login'"
          >
            Ainda não tenho cadastro
          </button>
          <button
            type="button"
            class="btn btn-outline-color2"
            @click="formType = 'login'"
            v-else
          >
            Já sou cadastrado
          </button>
        </div>

      </div>

      <div class="2fa-form" v-if="formType === 'use_2fa'">

        <div class="default-form mt-4">
          <template>
             <div>
              <p class="text-center font-size-small">
                Sua conta foi configurada para usar autenticação em dois fatores. Digite o código enviado ao seu email no campo abaixo
              </p>
              <p class="text-center font-size-xSmall" v-if="useResendCode">
                <strong>Um novo código foi enviado para o seu email. Digite o código enviado ao seu email no campo abaixo</strong>
              </p>
             </div>
            <div class="form-group default-input">
              <input type="text" class="form-control with-label" v-model.trim="code" placeholder="" />
              <label>Código de verificação</label>
            </div>
          </template>
          <div class="text-center mt-4 group-buttons d-flex flex-column">
            <div class="mb-3">
              <Button
                type="submit"
                class="btn-clean font-size-xSmall text-color2"
                @click="reSendCode"
                :loading="isResending2FA"
              >
                Não recebeu? <br>Enviar código novamente
              </Button>
            </div>
            <Button
              type="submit"
              class="btn btn-primary"
               v-on:click="validateCode2fa"
              :loading="isLoading"
              :disabled="isResending2FA"
            >
              Enviar
            </Button>
          </div>

        </div>
      </div>

    </template>
  </b-modal>
</template>

<script>

import { required, email } from 'vuelidate/lib/validators'
import AuthService from '@/modules/auth/services/auth-service'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import FacebookLogin from '@/components/auth/FacebookLogin'

export default {
  name: 'AuthModal',
  components: {
    Button,
    AlertWraper,
    FacebookLogin
  },
  data () {
    return {
      hidePassword: true,
      hideConfirmationPassword: true,
      formType: 'login',
      isLoading: false,
      isFbLoading: false,
      errors: null,
      code: null,
      emailTo2fa: null,
      useResendCode: false,
      isResending2FA: false,
      register: {
        email: '',
        password: '',
        password_confirmation: '',
        username: '',
        name: ''
      },
      login: {
        email: '',
        password: ''
      }
    }
  },
  validations () {
    if (this.formType === 'login') {
      return {
        login: {
          email: { required },
          password: { required }
        }
      }
    } else {
      return {
        register: {
          email: { required, email },
          password: { required },
          password_confirmation: { required },
          username: { required },
          name: { required }
        }
      }
    }
  },
  computed: {
    formTitle () {
      let title = null

      switch (this.formType) {
        case 'login':
          title = 'Faça login'
          break
        case 'register':
          title = 'Faça seu cadastro'
          break
        case 'use_2fa':
          title = 'Autenticação em dois fatores'
          break
        default:
          break
      }

      return title
    },
    passwordFieldType () {
      return this.hidePassword ? 'password' : 'text'
    },
    pwdIcon () {
      return this.hidePassword ? 'fa-eye' : 'fa-eye-slash'
    },
    confirmationPasswordFieldType () {
      return this.hideConfirmationPassword ? 'password' : 'text'
    },
    pwdConfirmIcon () {
      return this.hideConfirmationPassword ? 'fa-eye' : 'fa-eye-slash'
    }
  },
  methods: {
    async validateCode2fa () {
      this.isLoading = true
      this.errors = null
      try {
        await AuthService.validateCode2fa({ code: this.code, email: this.emailTo2fa })
        location.reload()
      } catch (error) {
        const { data } = error.response
        this.errors = data.errors
      }
      this.isLoading = false
    },
    async reSendCode () {
      this.isResending2FA = true
      this.errors = null
      this.useResendCode = false
      try {
        await AuthService.reSendCode2fa({ email: this.emailTo2fa })
        this.useResendCode = true
      } catch (error) {
        const { data } = error.response
        this.errors = data.errors
      }
      this.isResending2FA = false
    },
    async submitForm () {
      this.isLoading = true
      this.errors = null
      try {
        if (this.formType === 'login') {
          const response = await AuthService.login(this.login)
          if (response.use_2fa) {
            this.emailTo2fa = response.email
            this.formType = 'use_2fa'
          } else {
            location.reload()
          }
        } else {
          const response = await AuthService.register(this.register)
          // eslint-disable-next-line no-unused-vars, camelcase
          window.enhanced_conversion_data = {
            email: response.user.email
          }
          // eslint-disable-next-line no-undef
          gtag('event', 'conversion', {
            send_to: 'AW-379744698/8wL6CP_wrfsCELrjibUB'
          })

          location.reload()
        }
      } catch (error) {
        const { data } = error.response
        this.errors = data.errors
      }
      this.isLoading = false
    },
    async loginWithToken (value) {
      this.isFbLoading = true
      this.errors = null
      try {
        const token = value
        await AuthService.login({ fb_token: token })
        location.reload()
      } catch (error) {
        const { data } = error.response
        this.errors = data.errors
      }
      this.isFbLoading = false
    },
    reset () {
      this.formType = 'login'
      this.errors = null
      this.login.email = ''
      this.login.password = ''
      this.register.email = ''
      this.register.password = ''
      this.register.password_confirmation = ''
      this.register.username = ''
      this.register.name = ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .group-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    @include tablet {
      flex-direction: row;
    }
  }

  .button-reSendCode {
    margin-top: 15px;
    @include tablet {
      margin-left: 15px;
      margin-top: 0;
    }
  }
</style>
